import type { Template } from "@/types";

export const LA_03_H3_V0: Template[] = [
{
    id: "la-03-h3v0-01",
    name: "LA 01 - H3V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h3_v0_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 59, y: 58, width: 517, height: 359, rotation: 0, imageRotation: 0 },
            { id: "2", x: 796, y: 58, width: 319, height: 177, rotation: 0, imageRotation: 0 },
            { id: "3", x: 796, y: 242, width: 319, height: 176, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h3v0-02",
    name: "LA 02 - H3V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h3_v0_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 158, y: 58, width: 319, height: 177, rotation: 0, imageRotation: 0 },
            { id: "2", x: 158, y: 242, width: 319, height: 176, rotation: 0, imageRotation: 0 },
            { id: "3", x: 697, y: 58, width: 517, height: 359, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h3v0-03",
    name: "LA 03 - H3V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h3_v0_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 48, y: 49, width: 542, height: 378, rotation: 0, imageRotation: 0 },
            { id: "2", x: 680, y: 142, width: 272, height: 192, rotation: 0, imageRotation: 0 },
            { id: "3", x: 960, y: 142, width: 271, height: 192, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h3v0-04",
    name: "LA 04 - H3V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h3_v0_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 0, width: 637, height: 476, rotation: 0, imageRotation: 0 },
            { id: "2", x: 665, y: 137, width: 287, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 960, y: 137, width: 286, height: 203, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h3v0-05",
    name: "LA 05 - H3V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h3_v0_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 40, y: 108, width: 394, height: 260, rotation: 0, imageRotation: 0 },
            { id: "2", x: 441, y: 108, width: 394, height: 260, rotation: 0, imageRotation: 0 },
            { id: "3", x: 842, y: 108, width: 393, height: 260, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h3v0-06",
    name: "LA 06 - H3V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h3_v0_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 27, y: 137, width: 286, height: 203, rotation: 0, imageRotation: 0 },
            { id: "2", x: 321, y: 137, width: 287, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 637, y: 0, width: 637, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h3v0-07",
    name: "LA 07 - H3V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h3_v0_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 93, y: 122, width: 358, height: 232, rotation: 0, imageRotation: 0 },
            { id: "2", x: 459, y: 122, width: 358, height: 232, rotation: 0, imageRotation: 0 },
            { id: "3", x: 825, y: 122, width: 357, height: 232, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h3v0-08",
    name: "LA 08 - H3V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h3_v0_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 93, width: 420, height: 290, rotation: 0, imageRotation: 0 },
            { id: "2", x: 428, y: 93, width: 419, height: 290, rotation: 0, imageRotation: 0 },
            { id: "3", x: 855, y: 93, width: 419, height: 290, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h3v0-09",
    name: "LA 09 - H3V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h3_v0_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 118, y: 35, width: 339, height: 200, rotation: 0, imageRotation: 0 },
            { id: "2", x: 118, y: 242, width: 339, height: 200, rotation: 0, imageRotation: 0 },
            { id: "3", x: 608, y: 35, width: 631, height: 404, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h3v0-10",
    name: "LA 10 - H3V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h3_v0_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 43, y: 149, width: 287, height: 177, rotation: 0, imageRotation: 0 },
            { id: "2", x: 338, y: 53, width: 598, height: 370, rotation: 0, imageRotation: 0 },
            { id: "3", x: 944, y: 149, width: 287, height: 177, rotation: 0, imageRotation: 0 }
    ],
}
];